import { render, staticRenderFns } from "./staffPerformance.vue?vue&type=template&id=dedc8096&"
import script from "./staffPerformance.vue?vue&type=script&lang=js&"
export * from "./staffPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports